import { memo, useMemo, useCallback } from "react";
import { BioConfigForm } from "./forms/BioConfigForm";
import LinksConfigForm from "./forms/LinksConfigForm";
import ImageGalleryConfigForm from "./forms/ImageGalleryConfigForm";
import SingleMediaConfigForm from "./forms/SingleMediaConfigForm";
import MiniLinkConfigForm from "./forms/MiniLinkConfigForm";
import FileConfigForm from "./forms/FileConfigForm";
import RichTextLinkConfigForm from "./forms/RichTextLinkConfigForm";
import VideoPlayerConfigForm from "./forms/VideoPlayerConfigForm";
import SpotifyConfigForm from "./forms/SpotifyConfigForm";
import AppleMusicConfigForm from "./forms/AppleMusicConfigForm";
import CalendlyConfigForm from "./forms/CalendlyConfigForm";
import OpenTableConfigForm from "./forms/OpenTableConfigForm";
import MapConfigForm from "./forms/MapConfigForm";
import DividerConfigForm from "./forms/DividerConfigForm";
import PhotoAlbumConfigForm from "./forms/PhotoAlbumConfigForm";

const CONFIG_FORMS = {
  bio: BioConfigForm,
  links: LinksConfigForm,
  image_gallery: ImageGalleryConfigForm,
  single_media: SingleMediaConfigForm,
  mini_link: MiniLinkConfigForm,
  file: FileConfigForm,
  rich_text: RichTextLinkConfigForm,
  video_player: VideoPlayerConfigForm,
  spotify: SpotifyConfigForm,
  apple_music: AppleMusicConfigForm,
  calendly: CalendlyConfigForm,
  opentable: OpenTableConfigForm,
  map: MapConfigForm,
  divider: DividerConfigForm,
  photo_album: PhotoAlbumConfigForm,
};

const ConfigSettings = memo(function ConfigSettings({
  widget,
  handleWidgetUpdate,
}) {
  const widgetType = useMemo(
    () => widget.widget_type.type,
    [widget.widget_type.type]
  );

  const ConfigForm = useMemo(() => CONFIG_FORMS[widgetType], [widgetType]);

  // Create an adapter function for onUpdate
  const handleConfigUpdate = useCallback(
    (updates) => {
      handleWidgetUpdate(widget.id, {
        config: { ...widget.config, ...updates },
      });
    },
    [handleWidgetUpdate, widget.id, widget.config]
  );

  const memoizedConfig = useMemo(
    () => ({
      config: widget.config,
      onUpdate: handleConfigUpdate,
      handleWidgetUpdate,
      widgetId: widget.id,
      spaceId: widget.space_id,
    }),
    [
      widget.config,
      handleConfigUpdate,
      handleWidgetUpdate,
      widget.id,
      widget.space_id,
    ]
  );

  if (!ConfigForm) {
    return <div>No configuration available for this widget type</div>;
  }

  return (
    <div className="w-full">
      <ConfigForm {...memoizedConfig} />
    </div>
  );
});

ConfigSettings.displayName = "ConfigSettings";

export default ConfigSettings;
